var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 18.3C14.1167 18.1167 14.025 17.8834 14.025 17.6C14.025 17.3167 14.1167 17.0834 14.3 16.9L18.2 13H3C2.71667 13 2.47933 12.904 2.288 12.712C2.096 12.5207 2 12.2834 2 12C2 11.7167 2.096 11.479 2.288 11.287C2.47933 11.0957 2.71667 11 3 11H18.2L14.3 7.10005C14.1167 6.91672 14.025 6.68338 14.025 6.40005C14.025 6.11672 14.1167 5.88338 14.3 5.70005C14.4833 5.51672 14.7167 5.42505 15 5.42505C15.2833 5.42505 15.5167 5.51672 15.7 5.70005L21.3 11.3C21.4 11.4 21.471 11.5084 21.513 11.625C21.5543 11.7417 21.575 11.8667 21.575 12C21.575 12.1334 21.5543 12.2584 21.513 12.375C21.471 12.4917 21.4 12.6 21.3 12.7L15.7 18.3C15.5167 18.4834 15.2833 18.575 15 18.575C14.7167 18.575 14.4833 18.4834 14.3 18.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEast);
export default __webpack_public_path__ + "static/media/east.0d9a448758962083c4595ef7ec554fac.svg";
export { ForwardRef as ReactComponent };